<div class="target" data-cy="target-container">
  <span
    *ngIf="!!foodCostTarget && displayIcon"
    class="circle"
    data-cy="target-circle"
    [class.above-target]="foodCostTargetRef.aboveTarget === foodCostTarget"
    [class.below-target]="foodCostTargetRef.belowTarget === foodCostTarget"
    [class.on-track]="foodCostTargetRef.onTrack === foodCostTarget"
  ></span>
  <p
    data-cy="target-label"
    [class.above-target]="foodCostTargetRef.aboveTarget === foodCostTarget"
    [class.below-target]="foodCostTargetRef.belowTarget === foodCostTarget"
    [class.on-track]="foodCostTargetRef.onTrack === foodCostTarget"
  >
    {{ (foodCostTarget ?? 'N/A' )| translate }}
  </p>
</div>
